<template>
    <nav class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme" id="layout-navbar">
        <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
            <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)">
                <i class="bx bx-menu bx-sm"></i>
            </a>
        </div>

        <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
            <div class="navbar-nav align-items-center">
                <div class="nav-item d-flex align-items-center">
                    <i class="bx bx-search fs-4 lh-0"></i>
                    <input type="text" class="form-control border-0 shadow-none" placeholder="Search..." aria-label="Search..." />
                </div>
            </div>
            <ul class="navbar-nav flex-row align-items-center ms-auto">
                <li class="nav-item navbar-dropdown dropdown-user dropdown" ref="dropdown">
                    <a class="nav-link dropdown-toggle hide-arrow" href="#" @click.prevent="toggleMenu" data-bs-toggle="dropdown">
                        <div class="avatar avatar-online">
                            <img :src="avatar" alt class="w-px-40 h-auto rounded-circle" />
                        </div>
                    </a>
                    <ul :class="divClass" data-bs-popper="none">
                        <li>
                            <a class="dropdown-item" href="#">
                                <div class="d-flex">
                                <div class="flex-shrink-0 me-3">
                                    <div class="avatar avatar-online">
                                    <img :src="avatar" alt class="w-px-40 h-auto rounded-circle" />
                                    </div>
                                </div>
                                <div class="flex-grow-1">
                                    <span class="fw-semibold d-block">{{ firstName }} {{ lastname }}</span>
                                    <small class="text-muted">{{ companyName }}</small>
                                </div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <div class="dropdown-divider"></div>
                        </li>
                        <li>
                            <router-link to="/profile" class="dropdown-item">
                                <i class="bx bx-user me-2"></i>
                                <span class="align-middle">My Profile</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/services" class="dropdown-item">
                                <i class="bx bx-cog me-2"></i>
                                <span class="align-middle">Products/Services</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/billing" class="dropdown-item">
                                <span class="d-flex align-items-center align-middle">
                                    <i class="flex-shrink-0 bx bx-credit-card me-2"></i>
                                    <span class="flex-grow-1 align-middle">Billing</span>
                                    <span class="flex-shrink-0 badge badge-center rounded-pill bg-danger w-px-20 h-px-20">{{ billingCount }}</span>
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <div class="dropdown-divider"></div>
                        </li>
                        <li>
                            <a class="dropdown-item" href="#" @click.prevent="logout">
                                <i class="bx bx-power-off me-2"></i>
                                <span class="align-middle">Log Out</span>
                            </a>
                        </li>
                    </ul>


                </li>
                
            </ul>
        </div>

    </nav>
</template>

<script>
    export default {
        name: 'Navbar',
        data() {
            return {
                avatar: require('@/assets/images/avatar-empty.png'),
                isMenuShow: false,
                firstName: '',
                lastname: '',
                companyName: '',
                billingCount: 0
            };
        },
        created() {
            this.firstName = localStorage.getItem('firstName');
            this.lastname = localStorage.getItem('lastname');
            this.companyName = localStorage.getItem('companyName');
        },
        computed: {
            divClass() {
                return {
                    //dropdown-menu show dropdown-menu-end
                    'show': this.isMenuShow,
                    'dropdown-menu': true,
                    'dropdown-menu-end': true
                };
            },
        },
        methods: {
            toggleMenu() {
                this.billingCount = localStorage.getItem('billingCount');
                this.isMenuShow = !this.isMenuShow;
            },
            closeMenuIfClickedOutside(event) {
                // Check if the click happened outside the dropdown
                if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                    this.isMenuShow = false;
                }
            },
            logout() {
                
                // localStorage.removeItem('user');
                // localStorage.removeItem('email');
                // localStorage.removeItem('customerId');
                // localStorage.removeItem('firstName');
                // localStorage.removeItem('lastName');
                // localStorage.removeItem('website');
                // localStorage.removeItem('companyName');
                localStorage.clear();
                sessionStorage.clear();
                this.$emit('updateMembershipStatus');
                this.$router.push('/login'); // Redirect to login
            },
        },
        mounted() {
            // Add event listener for click outside the dropdown when component is mounted
            document.addEventListener('click', this.closeMenuIfClickedOutside);
        },
        // beforeDestroy() {
        //     // Clean up the event listener when the component is destroyed
        //     document.removeEventListener('click', this.closeMenuIfClickedOutside);
        // },
    };
</script>

<style scoped>

</style>